export const HI = {
  "Open document": "à¤¦à¤¸à¥à¤¤à¤¾à¤µà¥à¤à¤¼ à¤à¥à¤²à¥à¤",
  "Upload file": "à¤«à¤¼à¤¾à¤à¤² à¤à¤ªà¤²à¥à¤¡ à¤à¤°à¥à¤",
  "Drop file here to upload": "à¤à¤ªà¤²à¥à¤¡ à¤à¤°à¤¨à¥ à¤à¥ à¤²à¤¿à¤ à¤«à¤¼à¤¾à¤à¤² à¤¯à¤¹à¤¾à¤ à¤à¥à¤¡à¤¼à¥à¤",
  "Disc": "à¤¡à¤¿à¤¸à¥à¤",
  "URL": "à¤¯à¥à¤à¤°à¤à¤²",
  "FILE": "à¤«à¤¼à¤¾à¤à¤²",
  "SIZE": "à¤à¤à¤¾à¤°",
  "MB": "à¤à¤®à¤¬à¥",
  "KB": "à¤à¥à¤¬à¥",
  "Bytes": "à¤¬à¤¾à¤à¤à¥à¤¸",
  "Loading... Please wait.": "à¤²à¥à¤¡ à¤¹à¥ à¤°à¤¹à¤¾ à¤¹à¥ à¤à¥à¤ªà¤¯à¤¾ à¤ªà¥à¤°à¤¤à¥à¤à¥à¤·à¤¾ à¤à¤°à¥à¤à¥¤",
  "Fit Width": "à¤à¥à¤¡à¤¼à¤¾à¤ à¤ªà¤° à¤«à¤¼à¤¿à¤",
  "Fit Height": "à¤ à¥à¤ à¤à¤à¤à¤¾à¤",
  "Password protected document": "à¤ªà¤¾à¤¸à¤µà¤°à¥à¤¡ à¤¸à¥ à¤¸à¥à¤°à¤à¥à¤·à¤¿à¤¤ à¤¦à¤¸à¥à¤¤à¤¾à¤µà¥à¤à¤¼",
  "Password": "à¤ªà¤¾à¤¸à¤µà¤°à¥à¤¡",
  "Open": "à¤à¥à¤²à¤¨à¤¾",
  "Password Required": "à¤ªà¤¾à¤¸à¤µà¤°à¥à¤¡ à¤à¤µà¤¶à¥à¤¯à¤",
  "Incorrect password": "à¤à¤²à¤¤ à¤ªà¤¾à¤¸à¤µà¤°à¥à¤¡",
  "Error": "à¤¤à¥à¤°à¥à¤à¤¿",
  "Something went wrong": "à¤à¥à¤ à¤à¤²à¤¤ à¤¹à¥ à¤à¤¯à¤¾",
  "Server is not available": "à¤¸à¤°à¥à¤µà¤° à¤à¤ªà¤²à¤¬à¥à¤§ à¤¨à¤¹à¥à¤ à¤¹à¥",
  "of": "à¤à¤¾",
  "Please wait...": "à¤à¥à¤ªà¤¯à¤¾ à¤ªà¥à¤°à¤¤à¥à¤à¥à¤·à¤¾ à¤à¤°à¥à¤..."
};
